<template>
  <b-modal id="activity-response-modal" scrollable ref="activityResponseModal" size="lg" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop" hide-footer hide-header @hidden="resetModalValues">
    <div v-if="responseActivityDetail && questionDetailsObj">
      <div class="top-header">
        <div v-if="multipleResponseSubmittedDates && allDone === true" class="other-responses-list">
          <div @click="toggleDatesDropDown" class="selectedResponse" ref="responsesDatesDropDown">
            {{ selectedResponse | formatUTCDate }}
            <span class="dropdown-icon">
              <img alt="" src="static/img/arrow-down.png" />
            </span>
          </div>

          <div v-show="showResponseDropdown" class="autocomplete-items" :style="{ 'max-height': `${responseDateHeight}px` }" ref="otherResponsesDropdown">
            <div
              v-for="(submittedRes, rindex) in multipleResponseSubmittedDates"
              :key="rindex"
              class="item-detail"
              :class="{ active: rindex == selectedResponseIndex }"
              v-on="
                selectedResponseIndex != rindex
                  ? {
                      click: () => {
                        changeResponse(submittedRes);
                        selectedResponseIndex = rindex;
                        showResponseDropdown = false;
                      }
                    }
                  : {}
              "
            >
              <div>
                <span class="day mr-8">Day {{ submittedRes.completedDay }}</span>
                <span class="mr-10">{{ submittedRes.status }}</span>
                {{ new Date(submittedRes.completedOn) | formatUTCDate }}
                <span v-if="rindex == 0" class="day ml-10">Latest</span>
              </div>
            </div>
          </div>
        </div>
        <!-- End other response list -->

        <div class="other-responses-list" v-if="otherSubmittedResponse && otherSubmittedResponse.length == 1">
          <span class="mr-10">{{ otherSubmittedResponse[0].status }}</span
          >{{ new Date(otherSubmittedResponse[0].completedOn) | formatUTCDate }}
        </div>
        <b-form-select v-model="responseLanguage" size="sm" :options="responseLanguageOptions" class="language-dropdown"></b-form-select>
        <button class="close-icon" @click="hide()">
          <span class="fa fa-times"></span>
        </button>
      </div>

      <div class="heading">
        <div v-if="multipleResponseSubmittedDates" v-on="!oldestResponse ? { click: () => navigateResponse(-1) } : {}" class="left-arrow" :disabled="oldestResponse" :class="{ 'arrow-disabled': oldestResponse }">
          <span class="fa fa-long-arrow-left"></span>
        </div>

        <div class="activity-name fs-16">
          {{ responseActivityDetail.name === "iHealth Track BPM" ? "BPM Monitoring" : responseActivityDetail.name }}
          <div v-if="showTotalScore && displayingResponse.length > 0">
            <div class="totalScoreLayout">
              <span class="totalScoreText">Total Score</span>
              <button type="button" class="fw-bold ml-10 btn btn-primary totalScoreBtnValue">
                <span class="totalValue">{{ totalScoreValue }}</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="multipleResponseSubmittedDates" v-on="!latestResponse ? { click: () => navigateResponse(1) } : {}" class="right-arrow" :disabled="latestResponse" :class="{ 'arrow-disabled': latestResponse }">
          <span class="fa fa-long-arrow-right"></span>
        </div>
      </div>

      <div id="response-container" class="response-container">
        <div v-if="displayingResponse && displayingResponse.length > 0 && allDone === true">
          <div class="row que-ans-heading">
            <div class="col-md-5">
              <strong>QUESTION</strong>
            </div>
            <div class="col-md-7 pl-25">
              <strong>ANSWER</strong>
            </div>
          </div>
          <div class="answers">
            <div v-for="(ques, index) in questionAnswers" :key="index" class="row response">
              <div class="col-md-5">
                <span class="index-no">{{ index + 1 }}.</span>
                <div class="question-text-format ml-20 fs-14">
                  <div v-html="ques.displayQuestionText"></div>

                  <div v-if="ques.questionType == 'ImageCapture'" ref="image-capture-video-popup" :id="ques.id">
                    <div class="image-capture-iframe" v-html="ques.questionInformation" />
                  </div>
                </div>
              </div>
              <div class="col-md-7 answer-text font-weight-bold">
                <div v-if="ques.questionType == 'Image'" class="d-flex flex-wrap">
                  <div v-for="(imgURL, imgIndex) in ques.imageUrls" :key="imgIndex" class="mb-15 mr-15 d-inline-block activity-response-modal__img">
                    <img @contextmenu.prevent v-if="imgURL" class="img-response" :src="imgURL" alt="image response" />
                    <div class="d-flex w-90 h-100 img-thumbnail" v-else>
                      <div class="row justify-content-center align-self-center p-28">
                        N/A
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="ques.questionType == 'DateTime'">
                  <div>
                    {{ ques.answerText ? getDateTime(ques) : "" }}
                    <ClockIconPopup v-if="isDateTime(ques)" :answer="ques.answerText" :id="ques.questionId" />
                  </div>
                </div>
                <div v-else-if="ques.questionType == 'ImageCapture'" class="image-capture">
                  <div>
                    <div v-if="ques.isQrCode" class="break-word" v-html="ques[JsonFieldToDisplay]"></div>
                    <img @contextmenu.prevent v-else-if="ques.imageUrls" class="img-response d-block" :src="!!ques.thumbnailUrls[0] ? ques.thumbnailUrls[0] : ques.imageUrls[0]" alt="image response" />
                    <div v-else>
                      <p>{{ ques.answerText }}</p>
                      <p>{{ new Date(ques.startTime) | formatGMTDate }}</p>
                    </div>
                  </div>
                </div>
                <div v-else-if="ques.questionType == 'GPSkin'" class="gpskin">
                  <div v-for="(ans, gi) in ques.answerText" :key="gi" class="row">
                    <div class="col-md-4 p-0">{{ ans.attribute }}</div>
                    <div class="col-md-8">{{ ans.value }} {{ ans.unit }}</div>
                  </div>
                </div>
                <!-- Skin Analyser -->
                <div class="answerSkin" v-else-if="ques.questionType === 'SkinAnalyser'">
                  <div class="row">
                    <div class="fRow" v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Overview')" :key="index">
                      <div class="image-edit-mode d-flex flex-wrap mb-12 mr-12">
                        <div class="position-relative">
                          <img @contextmenu.prevent class="image-edit-mode__image__overview" :src="item.imageURL" alt="image response" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="skin-left-margin">
                        <div class="row" v-if="ques.displayAnswerText != ''">
                          <span class="text-redness-dryness">Redness</span>
                        </div>
                        <div class="row">
                          <div v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Redness')" :key="index">
                            <div class="image-edit-mode d-flex flex-wrap mb-bottom mr-12">
                              <div class="position-relative">
                                <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="item.imageURL" alt="image response" />
                              </div>
                            </div>
                            <div class="row">
                              <div class="progress progress-redness mr-bottom-5">
                                <div
                                  class="progress-bar progress-bar-redness progress-bar-success"
                                  role="progressbar"
                                  :aria-valuenow="item.imageScore"
                                  aria-valuemin="0"
                                  aria-valuemax="5"
                                  :style="{
                                    width: calculateBarWidth(item.imageScore, 5) + '%'
                                  }"
                                >
                                  <span class="sr-only">{{ item.imageScore | decimalThreeDigit }}% Complete</span>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <span class="rank-redness">
                                {{ item.imageScore | decimalThreeDigit }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="dryness-left-margin">
                      <div class="row" v-if="ques.displayAnswerText != ''">
                        <span class="text-redness-dryness">Dryness</span>
                      </div>
                      <div class="row">
                        <div v-for="(item, index) of stringToJsonConvert(ques.displayAnswerText, 'Dryness')" :key="index">
                          <div class="image-edit-mode d-flex flex-wrap mb-bottom">
                            <div class="position-relative">
                              <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="item.imageURL" alt="image response" />
                            </div>
                          </div>
                          <div class="row">
                            <div class="progress progress-dryness mr-bottom-5">
                              <div
                                class="progress-bar progress-bar-dryness progress-bar-success"
                                role="progressbar"
                                :aria-valuenow="item.imageScore"
                                aria-valuemin="0"
                                aria-valuemax="5"
                                :style="{
                                  width: calculateBarWidth(item.imageScore, 5) + '%'
                                }"
                              >
                                <span class="sr-only">{{ item.imageScore | decimalThreeDigit }}% Complete</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <span class="rank-redness">
                              {{ item.imageScore | decimalThreeDigit }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="ques.questionType == 'MedicationSelector'">
                  <medication-response :mode="0" :answer="ques" :usage="usageAsPerAPI" :show-title="false" :model-preview="true" :selected-language-culture="responseLanguage" />
                </div>

                <div v-else-if="ques.questionType == 'AudioRecording'">
                  <audio-response :mode="0" :answer="ques" :usage="usageAsPerAPI" :show-title="false" :model-preview="true" :selected-language-culture="responseLanguage" />
                </div>

                <div v-else-if="ques.questionType == 'VideoRecording'">
                  <video-response :mode="0" :answer="ques" :usage="usageAsPerAPI" :show-title="false" :selected-language-culture="responseLanguage" />
                </div>
                <div v-else-if="ques.questionType == 'WongBaker'">
                  <div class="row">
                    <div class="col-md-12 p-0">
                      <div class="row p-0 m-0 mt-5">
                        <div class="text-center  wong-baker-count-box">
                          <input type="number" class="wong-baker-count d-block mx-auto" v-model="ques.answerText" disabled="disabled" placeholder="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="break-word" v-html="ques[JsonFieldToDisplay]"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="responseActivityDetail.name === 'iHealth Track BPM'">
          <div class="row que-ans-heading">
            <div class="col-md-4 pt-22 pl-31 pb-8" style="border-right: 3px solid #ffffff;">
              <strong>QUESTION</strong>
            </div>
            <div class="col-md-8 pt-22 pl-31 pb-8">
              <strong>ANSWER</strong>
            </div>
          </div>
          <!-- staic contents -->
          <div class="row answers ">
            <div class="col col-md-4 pl-31 pt-12">
              <p class="mt-3 mb-0">iHealth Track BPM</p>
              <h6>Monitor your BPM</h6>
            </div>
            <div class="col-md-8 ">
              <table aria-describedby="" class="table healthtrack-table">
                <thead>
                  <tr>
                    <td>
                      <h6 class="text-upprercase mb-0">SYS</h6>
                      <p class="mb-0"><i>mmHg</i></p>
                    </td>
                    <td>
                      <h6 class="text-upprercase mb-0">Dia</h6>
                      <p class="mb-0"><i>mmHg</i></p>
                    </td>
                    <td>
                      <h6 class="text-upprercase mb-0">Pulse</h6>
                      <p class="mb-0"><i>Beats/Min</i></p>
                    </td>
                    <td>
                      <h6 class="text-upprercase mb-0">
                        Arm <br />
                        used
                      </h6>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(activity, index) in activityResponsePayload" :key="index">
                    <td>
                      <b>{{ activity.systolic }} </b>
                    </td>
                    <td>
                      <b>{{ activity.diastolic }}</b>
                    </td>
                    <td>
                      <b>{{ activity.heartRate }}</b>
                    </td>
                    <td>
                      <b>{{ activity.arm || "-" }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else-if="activityResponsePayload && allDone === true">
          <JsonTree :treeOpen="true" :json="activityResponsePayload" />
        </div>
        <div v-else class="snippet" :class="{ 'dot-loader': responseActivityDetail && allDone === true }" data-title=".dot-stretching">
          <div class="stage">
            <div class="dot-stretching"></div>
          </div>
        </div>
        <div class="mod-footer text-center">
          <div class="footer-text">End of Participant Reported Data</div>
          <div v-show="showScrollUp" class="scroll-top" @click="scrollUp()">
            scroll to top
          </div>
        </div>
      </div>
    </div>
    <div v-else class="snippet" data-title=".dot-stretching">
      <div class="stage">
        <div class="dot-stretching"></div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import moment from "moment";
import _ from "lodash";
import ClockIconPopup from "@/components/common/clock-icon-popup";
import MultilingualService from "@/components/services/multilingual-service";
import LocalStorageService from "@/services/localStorage";
import QlVideoUploadService from "@/services/ql-video-upload";
import AudioResponse from "./activity-response/activity-steps/audio-recording-response";
import VideoResponse from "./activity-response/activity-steps/video-recording-response";
import MedicationResponse from "./activity-response/activity-steps/medication-selector-response";
import { loadData } from "@/services/video-render";

export default {
  name: "participant-response-modal",
  props: ["responseActivityDetail", "responseLanguageOptions", "generalParticipantInfo", "showTotalScore"],
  components: {
    AudioResponse,
    VideoResponse,
    MedicationResponse,
    ClockIconPopup
  },
  data() {
    return {
      mlService: new MultilingualService(this.$route),
      surveyData: null,
      noCloseOnBackdrop: true,
      selectedResponse: null,
      //selectedResponseId: null,
      selectedResponseIndex: null,
      responseLanguage: "EN",
      multipleResponseSubmittedDates: null,
      questionAnswers: [],
      quesCollection: [],
      displayingResponse: [],
      showScrollUp: false,
      responseDateHeight: 200,
      showResponseDropdown: false,
      activityResponsePayload: null,
      otherSubmittedResponse: null,
      totalScoreValue: 0,
      qlVideoUpload: null,
      usageAsPerAPI: {
        QUESTION_TYPE: `questionType`,
        QUESTION_ID: `questionId`,
        QUESTION_TEXT: `questionBody`,
        ANSWER_TEXT: `answerText`,
        DISPLAY_ANSWER_TEXT: `displayAnswerText`,
        DISPLAY_QUESTION_TEXT: `displayQuestionText`
      },
      wongBackerFaces: [
        {
          greyImg: "static/img/activity-configurator/no-hurt-grey.svg",
          blueImg: "static/img/activity-configurator/no-hurt.svg",
          score: 0,
          text: "No Hurt"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-little-bit-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-little-bit.svg",
          score: 2,
          text: "Hurts Little Bit"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-little-more-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-little-more.svg",
          score: 4,
          text: "Hurts Little More"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-even-bit-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-even-bit.svg",
          score: 6,
          text: "Hurts Even bit"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-whole-lot-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-whole-lot.svg",
          score: 8,
          text: "Hurts Whole Lot"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-worse-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-worse.svg",
          score: 10,
          text: "Hurts Worse"
        }
      ]
    };
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService("survey", this.$route.params.studyId, LocalStorageService.getItem("clientId"));
    this.qlVideoUpload.screenType = "response";
  },
  created() {
    this.totalScoreValue = 0;
  },
  computed: {
    JsonFieldToDisplay() {
      return "displayAnswerText";
    },
    latestResponse() {
      if (!this.multipleResponseSubmittedDates) {
        return;
      }
      return this.selectedResponseIndex == 0;
    },
    oldestResponse() {
      if (!this.multipleResponseSubmittedDates) {
        return;
      }
      return this.selectedResponseIndex == this.multipleResponseSubmittedDates.length - 1;
    },
    allDone() {
      if (this.responseActivityDetail != null) {
        if (this.responseActivityDetail.type.toLowerCase() == "survey" && this.displayingResponse != null && this.displayingResponse.length > 0 && this.otherSubmittedResponse != null) {
          return true;
        } else if (this.responseActivityDetail.type.toLowerCase() == "activity" && this.activityResponsePayload != null && this.otherSubmittedResponse != null) {
          return true;
        }
      }
      return false;
    },
    questionDetailsObj() {
      if (!this.surveyData) {
        return {};
      }
      if (!this.surveyData.questions) {
        return {};
      }

      const questionDetails = this.surveyData.questions;
      const questionDetailsObj = {};
      questionDetails.forEach(question => {
        questionDetailsObj[question.id] = question;
      });

      return questionDetailsObj;
    }
  },

  filters: {
    dateFormat(value) {
      const formattedValue = moment(value).format("D MMMM YYYY");
      if (formattedValue === "Invalid date") {
        return value;
      }
      return formattedValue;
    },
    getFormattedDateForDropdown(value) {
      const datemoment = moment(value);
      const date = datemoment.format("MMMM D YYYY");
      const time = datemoment.format("hh:mm A");
      const formatted = `${date} at  ${time} UTC`;
      return formatted;
    },
    decimalThreeDigit(value) {
      const val = parseFloat(value).toFixed(3);
      return val > 0 ? val : 0.0;
    }
  },
  watch: {
    async responseLanguage(v) {
      const responseToDisplay = _.filter(this.quesCollection, ["language", v]);
      const selectedLanguage = _.find(this.responseLanguageOptions, opt => {
        return opt.value == v;
      });
      const languageId = !!selectedLanguage && !!selectedLanguage.languageId ? selectedLanguage.languageId : null;
      this.displayingResponse = responseToDisplay[0].question;
      const revisionId = this.surveyData.revisionId || null;
      await this.mlService.loadAppLangaKeys(this.$route, languageId);
      this.mlService.getAllQuestionTypeConversion(this.surveyData.questions, this.questionAnswers, v, revisionId).then(result => {
        this.questionAnswers = _.sortBy(result.response, "sequence");
        this.cleanAndReloadHTMLForImageCapture(v);
      });
    },
    responseActivityDetail(v) {
      if (v != null) {
        this.changeResponse(this.responseActivityDetail, "id");
        this.getActivitySubmmitedList();
      }
    },
    selectedResponseIndex(indx) {
      //Prepare the selected response date string and set the selected response id whenever the value gets changes from the dates dropdown or from the navigation arrows;
      if (indx != null) {
        this.prepareSelectedResponseDateString();
      }
    },
    surveyData() {
      const result = this.surveyData.questions.filter(object1 => !this.questionAnswers.some(object2 => object1.id === object2.questionId));
      result.forEach(r => {
        if (r.type !== "SurveyCompletion" && r.type !== "Section") {
          this.questionAnswers.push({
            questionBody: r.body,
            questionInformation: null,
            answerText: null,
            questionId: r.id,
            questionType: r.type,
            sequence: r.sequence,
            appLanguageId: this.questionAnswers[0].appLanguageId,
            displayLanguage: this.questionAnswers[0].displayLanguage,
            displayQuestionText: r.formattedBody,
            displayAnswerText: null
          });
        }
      });
      this.questionAnswers = _.sortBy(this.questionAnswers, "sequence");
    }
  },
  // mounted(){
  //   this.getSurveyData();
  // },

  methods: {
    isDateTime(ques){
      const allPossibleFormats = ["YYYY-MM-DDTHH:mm:ssZ", "YYYY-MM-DDTHH:mm:ss.SSSZ"];
      return moment(ques.answerText, allPossibleFormats, true).isValid();
    },
    stringToJsonConvert(stringData, type) {
      let list = [];
      if (stringData != "" && stringData != null && stringData != "undefined" && stringData.trim().length != 0) {
        list = JSON.parse(stringData);
      }
      let filterList = [];
      if (type == "Overview") {
        filterList = list.filter(item => item.imageType == "overview");
      }
      if (type == "Redness") {
        filterList = list.filter(item => item.imageType == "redness");
      }
      if (type == "Dryness") {
        filterList = list.filter(item => item.imageType == "dryness");
      }
      return filterList;
    },
    calculateBarWidth(currentValue, maxValue) {
      const width = (currentValue * 100) / maxValue;
      return width;
    },
    parseJson(jsonString) {
      return JSON.parse(jsonString);
    },
    show() {
      this.$refs.activityResponseModal.show();
    },
    hide() {
      this.responseLanguage = "EN";
      this.totalScoreValue = 0;
      this.$refs.activityResponseModal.hide();
    },
    changeResponse(responseObj, which = null) {
      this.showScrollUp = false;
      const responseType = responseObj.type.toLowerCase();
      if (responseType.toLowerCase() == "survey") {
        nprogress.start();
        this.getSurveyResponseDetails({
          surveyId: responseObj.id,
          completedOn: responseObj.completedOn,
          reportedDataTrackerId: responseObj.reportedDataTrackerId
        });
      } else {
        if (which != null) {
          this.getActivityResponseDetails(responseObj.reportedDataTrackerId);
          return;
        }
        this.getActivityResponseDetails(responseObj.id);
      }
    },
    getSurveyResponseDetails({ surveyId, completedOn, reportedDataTrackerId }) {
      this.questionAnswers = [];
      this.displayingResponse = [];
      this.quesCollection = [];

      if (this.responseActivityDetail) {
        const getReq = {
          studyId: this.$route.params.studyId,
          pid: this.$route.params.participantId,
          surveyId: surveyId,
          responseDate: completedOn
        };
        if (reportedDataTrackerId) {
          getReq.reportedDataTrackerId = reportedDataTrackerId;
        }
        this.$api.getSurvey(getReq).then(
          data => {
            this.getSurveyData(surveyId);
            //this.getApplangaKeys();
            nprogress.done();
            this.questionAnswers = _.sortBy(data.responses, "sequence");
            this.questionAnswers = this.questionAnswers.filter(response => {
              if (response.questionType.toLowerCase() === "surveyinstruction") {
                return true;
              }
              return true;
            });
            this.cleanAndReloadHTMLForImageCapture(this.responseLanguageOptions[0].value);

            this.prepareQuestions();
            this.totalScoreValue = data.totalScore ? data.totalScore : 0;
          },
          error => {
            nprogress.done();
            const { message = "Error while survey request" } = (error && error.body) || {};
            this.$toastr.error(message);
          }
        );
      }
    },
    getSurveyData(surveyId) {
      this.$api.getSurveyDetailsFact(this.$route.params.studyId, surveyId, "Survey").then(
        response => {
          this.surveyData = response.body;
          this.mlService.getAllQuestionTypeConversion(this.surveyData.questions, this.questionAnswers, this.responseLanguage).then(result => {
            this.questionAnswers = _.sortBy(result.response, "sequence");
            /* Below code will update the expired uploaded video urls */
            this.cleanAndReloadHTMLForImageCapture(this.responseLanguageOptions[0].value);
            this.prepareQuestions();
            this.$forceUpdate();
          });
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting survey details";
          this.$toastr.error(this.errorMsg);
        }
      );
    },
    getApplangaKeys() {
      this.$api.getApplangaCredentials(this.$route.params.studyId).then(
        response => {
          const time = new Date().getTime();
          const appId = response.body.data.applicationId;
          const appToken = response.body.data.applanagaTokenId;
          //** Axios Code */
          axios({
            method: "get",
            crossDomain: true,
            url: `https://api.applanga.com/v1/api?app=${appId}&includeUpdateDate=true#${time}`,
            headers: {
              Authorization: `Bearer ${appToken}`
            }
          })
            .then(response => {
              if (response) {
                this.allApplangaKeys = response.data.data;
                this.prepareQuestions();
              }
            })
            .catch(err => {
              throw err;
            });
          //** Axios Code */
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
        }
      );
    },

    getDateTime(value) {
      const {questionId, answerText, participantLocalTimeOffset } = value;
      const question = this.questionDetailsObj[questionId];
      let timeFormat = question && question.hasOwnProperty("timeFormat") &&  question.timeFormat ? question.timeFormat : "";
      const dateFormat = question && question.hasOwnProperty("dateFormat") && question.dateFormat ? question.dateFormat : "";
      const dateString = this.getFormattedDate(answerText, dateFormat, participantLocalTimeOffset, question);
      if (question && question.hasOwnProperty("showDate") && question.showDate && question.showTime) {
        const timeSting = this.getFormattedTime(answerText, timeFormat, participantLocalTimeOffset);
        return dateString + " " + timeSting;
      } else if (question && question.hasOwnProperty("showDate") && question.showDate) {
        return dateString;
      } else if (question && question.hasOwnProperty("showTime") && question.showTime) {
        const allPossibleFormats = ["hh:mm A", "HH:mm:ss A", "HH:mm", "HH:mm:ss"];
        const result = moment(answerText, allPossibleFormats, true).isValid();
        if (!result) {
          return "";
        }
        timeFormat = timeFormat == 12 ? "hh:mm A" : "HH:mm";
        const formattedTime = moment(answerText).utcOffset(participantLocalTimeOffset).format(timeFormat);
        if (formattedTime === "Invalid date") {
          if (timeFormat == "HH:mm") {
            return answerText.replace(/PM/g, "");
          } else {
            return answerText;
          }
        }
        return formattedTime;
      } else {
        return answerText;
      }
    },
    getFormattedDate(value, format, participantLocalTimeOffset, question = {}) {
      let dateFormat = "";
      const { subType } = question;
      switch (format) {
        case "dd/mm/yyyy":
          dateFormat = "D MMMM YYYY";
          break;
        case "mm/dd/yyyy":
          dateFormat = "MMMM D YYYY";
          break;
        case "yyyy/mm/dd":
          dateFormat = "YYYY MMMM D";
          break;
        case "yyyy/mm":
          dateFormat = "YYYY MMMM";
          break;
        case "mm/yyyy":
          dateFormat = "MMMM YYYY";
          break;
        case "yyyy":
          dateFormat = "YYYY";
          break;
        default:
          dateFormat = "D MMMM YYYY";
      }
      if (subType === "Date") {
        return moment(value).format(dateFormat);
      }
      return moment(value).utcOffset(participantLocalTimeOffset).format(dateFormat);
    },

    getFormattedTime(val, timeFormatOld,participantLocalTimeOffset) {
      let timeFormat = timeFormatOld;
      timeFormat = timeFormat == 12 ? "hh:mm A" : "HH:mm";

      const formattedTime = moment(val).utcOffset(participantLocalTimeOffset).format(timeFormat);
      if (formattedTime === "Invalid date") {
        return val;
      }
      return formattedTime;
    },

    getActivityResponseDetails(activityId) {
      this.activityResponsePayload = null;
      this.$api
        .getActivity({
          aId: activityId
        })
        .then(data => {
          this.activityResponsePayload = JSON.parse(data.payload);
        })
        .catch(error => {
          const { message = "Error while activity response request" } = (error && error.body) || {};
          this.$toastr.error(message);
        });
    },
    prepareQuestions() {
      const self = this;
      self.quesCollection = [{ language: "EN", question: self.questionAnswers }];

      _.map(self.quesCollection[0].question, function(q) {
        const questionType = q.questionType.toLowerCase();
        q.questionBody = self.$options.filters.stripTags(q.questionBody);

        if (questionType == "image" && q.languageImageUrls) {
          const imgUrls = _.filter(q.languageImageUrls, {
            languageCulture: "EN"
          });
          q.imageUrls = imgUrls[0].imageUrls;
        } else if (questionType == "gpskin") {
          const answerText = JSON.parse(q.answerText);
          q.answerText = answerText.gpskin.result;
        }
      }); //Map Ends

      if (this.responseLanguageOptions.length > 1) {
        const surveyData = this.surveyData;
        const langKeys = this.allApplangaKeys;
        const otherLang = _.cloneDeep(this.questionAnswers);

        _.map(otherLang, function(q) {
          const questionType = q.questionType.toLowerCase();
          q.questionBody = self.$options.filters.stripTags(q.displayQuestionText);
          q.answerText = q.displayAnswerText;

          if (langKeys != undefined && Object.keys(langKeys).length > 0 && langKeys.hasOwnProperty(self.responseLanguageOptions[1].value)) {
            const keysArray = langKeys[self.responseLanguageOptions[1].value]["main"]["entries"];

            if (keysArray.hasOwnProperty(q.questionId + "_body")) {
              q.questionBody = keysArray[q.questionId + "_body"].v;
            }

            if (q.questionType == "MultiChoice" || q.questionType == "Boolean") {
              const questions = surveyData.questions.filter(c => {
                if (c.id == q.questionId) {
                  return c.options;
                }
              });
              if (questions[0].options.length > 0) {
                questions[0].options.forEach(option => {
                  if (option.body == q.displayAnswerText) {
                    const booleanApplangaKey = q.questionId + "_options_" + option.id + "_label";
                    if (keysArray.hasOwnProperty(booleanApplangaKey)) {
                      q.answerText = keysArray[booleanApplangaKey].v;
                    }
                  }
                });
              }
            }

            if (q.questionType == "CustomScale") {
              const questions = surveyData.questions.filter(c => {
                if (c.id == q.questionId) {
                  return c.labels;
                }
              });
              if (questions[0].labels.length > 0) {
                if (questions[0].labels.indexOf(q.displayAnswerText) > -1) {
                  const booleanApplangaKey = q.questionId + "_labels_" + questions[0].labels.indexOf(q.displayAnswerText) + "_label";
                  if (keysArray.hasOwnProperty(booleanApplangaKey)) {
                    q.answerText = keysArray[booleanApplangaKey].v;
                  }
                }
              }
            }
          }

          if (questionType == "image" && q.languageImageUrls) {
            const imgUrls = _.filter(q.languageImageUrls, {
              languageCulture: q.displayLanguage
            });
            if (imgUrls.length) {
              q.imageUrls = imgUrls[0].imageUrls;
            }
          } else if (questionType == "gpskin") {
            const answerText = JSON.parse(q.answerText);
            q.answerText = answerText.gpskin.result;
          }
        }); //Map ends

        self.quesCollection.push({
          language: self.responseLanguageOptions[1].value,
          question: otherLang
        });
      } //End if

      const responseToDisplay = _.filter(self.quesCollection, ["language", self.responseLanguage]);
      this.displayingResponse = responseToDisplay[0].question;
    },
    getActivitySubmmitedList() {
      //Get all the submitted response for the survey being shown
      if (this.responseActivityDetail) {
        const getReq = {
          studyId: this.$route.params.studyId,
          pid: this.$route.params.participantId,
          id: this.responseActivityDetail.id,
          startDay: this.generalParticipantInfo.startDay,
          endDay: this.generalParticipantInfo.endDay,
          type: this.responseActivityDetail.type
        };

        this.$api.getSurveyResponsesList(getReq).then(
          data => {
            this.otherSubmittedResponse = data;
            if (data.length > 1) {
              const sortDataAsc = _.sortBy(data, ["completedOn"]);
              this.multipleResponseSubmittedDates = _.reverse(sortDataAsc); //Order by date so that latest comes first

              //Find the index of the response being displayed
              const responseType = this.responseActivityDetail.type.toLowerCase();
              if (responseType == "survey") {
                this.selectedResponseIndex = _.findIndex(this.multipleResponseSubmittedDates, ["reportedDataTrackerId", this.responseActivityDetail.reportedDataTrackerId]);
              } else {
                this.selectedResponseIndex = _.findIndex(this.multipleResponseSubmittedDates, ["id", this.responseActivityDetail.reportedDataTrackerId]);
              }
            }
          },
          error => {
            const { message = "Error while all submitted response" } = (error && error.body) || {};
            this.$toastr.error(message);
          }
        );
      }
    },
    toggleDatesDropDown() {
      this.showResponseDropdown = !this.showResponseDropdown;
      //this.$nextTick(() => {
      if (this.showResponseDropdown) {
        this.$refs.otherResponsesDropdown.focus();
      }
      //});
    },
    navigateResponse(move) {
      this.showResponseDropdown = false;
      if (move == 1) {
        this.selectedResponseIndex = this.selectedResponseIndex - 1;
      } else {
        this.selectedResponseIndex = this.selectedResponseIndex + 1;
      }
      this.changeResponse(this.multipleResponseSubmittedDates[this.selectedResponseIndex]);
    },
    prepareSelectedResponseDateString() {
      const displayedResponseObj = this.multipleResponseSubmittedDates[this.selectedResponseIndex];
      this.selectedResponse = new Date(displayedResponseObj.completedOn);
    },
    scrollUp() {
      window.$(".response-container").animate(
        {
          scrollTop: 0
        },
        100
      );
    },
    resetModalValues() {
      this.$emit("resetActivityResponse");
      this.selectedResponse = null;
      //this.selectedResponseId = null;
      this.selectedResponseIndex = null;
      this.responseLanguage = "EN";
      this.multipleResponseSubmittedDates = null;
      this.questionAnswers = [];
      this.quesCollection = [];
      this.displayingResponse = [];
      this.showScrollUp = false;
      this.allApplangaKeys = {};
      this.responseDateHeight = 200;
      this.showResponseDropdown = false;
      this.activityResponsePayload = null;
      this.otherSubmittedResponse = null;
    },
    cleanAndReloadHTMLForImageCapture(lang) {
      if (lang == "EN") {
        this.questionAnswers = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.questionAnswers, "questionBody");
        this.questionAnswers = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.questionAnswers, "questionInformation");
        if (this.surveyData) {
          this.qlVideoUpload.replaceSignedVideoS3Url(this.questionAnswers, "questionInformation", this.surveyData.participantVideos);
        }
      } else {
        this.questionAnswers = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.questionAnswers, "displayQuestionText");
        this.questionAnswers = this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(this.questionAnswers, "questionInformation");
        if (this.surveyData) {
          this.qlVideoUpload.replaceSignedVideoS3Url(this.questionAnswers, "questionInformation", this.surveyData.participantVideos);
        }
      }
    }
  },
  updated() {
    this.$nextTick(() => {
      const responseContainer = document.getElementById("response-container");
      if (responseContainer) {
        this.showScrollUp = responseContainer.scrollHeight > responseContainer.clientHeight;
      }
      const modalBody = document.getElementById("activity-response-modal___BV_modal_body_");
      this.responseDateHeight = modalBody.clientHeight - 100;
    });

    if (this.$refs["image-capture-video-popup"]) {
      this.$refs["image-capture-video-popup"].forEach(ele => {
        if (!ele.videoRendered) {
          loadData(ele);
          ele.videoRendered = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  /deep/ #activity-response-modal {
    .modal-dialog {
      min-width: 800px !important;
      width: 750px !important;
      vertical-align: top;
      max-height: calc(100% - 1rem);
      margin: 3.125rem auto;
    }
  }
}
#activity-response-modal {
  font-family: "Lato-Regular", sans-serif;
  .top-header {
    text-align: center;
    padding: 10px;
    position: relative;
    min-height: 40px;
    .response-dates {
      border: 0;
      width: auto;
      background: #f1f4f8 url(/static/img/arrow-down.png) no-repeat;
    }
    .language-dropdown {
      background: #f1f4f8 url(/static/img/arrow-down.png) no-repeat;
      border: 0;
      width: auto;
      position: absolute;
      right: 40px;
      top: 5px;
      background-position-x: 96% !important;
    }
    .close-icon {
      background: transparent;
      border: 0;
      opacity: 0.6;
      cursor: pointer;
      color: #000000;
      margin-right: 3px;
      float: right;
    }
  }
  .heading {
    text-align: center;
    color: #000000;
    font-size: 15px;
    padding: 12px 20px;
    background-color: #ffffff;
    .activity-name {
      display: inline-block;
    }
    .left-arrow {
      color: #4a90e2;
      float: left;
      cursor: pointer;
      &.arrow-disabled {
        color: #dee3e9;
        cursor: inherit;
      }
    }
    .right-arrow {
      color: #4a90e2;
      float: right;
      cursor: pointer;
      &.arrow-disabled {
        color: #dee3e9;
        cursor: inherit;
      }
    }
  }
  .modal-content {
    background-color: #f1f4f8;
    max-height: calc(100vh - 3.5rem);
  }
  .modal-body {
    padding: 0;
    overflow-y: hidden;
  }
  .response-container {
    scroll-behavior: smooth;
    max-height: calc(100vh - 12.063rem);
    overflow-y: auto;
    margin-top: 5px;
    background-color: #ffffff;
    padding: 20px 40px 0px 40px;
    color: #4a4a4a;

    //Scrollbar CSS for Mozilla
    scrollbar-color: #4a4a4a white; /* thumb and track color */
    scrollbar-width: thin;

    //Below is the scrollbar css for Chrome

    &::-webkit-scrollbar {
      width: 6px;
      background-color: #ffffff;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #e6e9ed;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      background-color: #ffffff;
    }
    .que-ans-heading {
      font-size: 11px;
      border-bottom: 1px solid #f1f4f8;
      background-color: #f9f9fb;
    }
    .answers {
      font-size: 13px;
      .response {
        padding-top: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);
        .index-no {
          float: left;
        }
        .answer-text {
          padding-left: 25px;
          .img-thumbnail {
            color: #4a4a4a;
            border: 1px solid #4a4a4a;
            opacity: 0.5;
          }
          .img-response {
            object-fit: cover;
            max-width: 100%;
          }
          .break-word {
            word-break: break-word;
          }
        }
      }
    }
    .mod-footer {
      color: #4a4a4a;
      font-size: 12px;
      margin-bottom: 10px;
      margin-top: 10px;
      position: relative;
      .footer-text {
        opacity: 0.4;
      }
      .scroll-top {
        color: #4a90e2;
        opacity: 1;
        right: 0px;
        top: 0;
        position: absolute;
        cursor: pointer;
      }
    }
  }

  .activity-response-modal__img {
    width: 100%;
  }

  .stage {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2rem 0;
    margin: 0 -5%;
    overflow: hidden;
  }

  //-----------------------
  /*Dates responses dropdown*/
  .other-responses-list {
    position: relative;
    display: inline-block;
    /* width: 100%; */
    .selectedResponse {
      cursor: context-menu;
      .dropdown-icon {
        margin-top: -2px;
        position: absolute;
      }
    }
  }
  .autocomplete-items {
    position: absolute;
    border: 1px solid #f1f4f8;
    border-top: none;
    z-index: 99;
    /*position the autocomplete items to be the same width as the container:*/
    top: 27px;
    left: -35px;
    right: 0;
    overflow-y: auto;
    border-radius: 2px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.31);
    width: max-content;
    outline: none;

    //Scrollbar CSS for Mozilla
    scrollbar-color: #4a4a4a white; /* thumb and track color */
    scrollbar-width: thin;

    //Below is the scrollbar css for Chrome

    &::-webkit-scrollbar {
      width: 6px;
      background-color: #ffffff;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #4a4a4a;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
      background-color: #ffffff;
    }

    .day {
      opacity: 0.3;
    }
  }
  .autocomplete-items .item-detail {
    padding: 7px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: solid 0.5px #f1f4f8;
    font-size: 12px;
    color: #4a4a4a;
    text-align: left;
    &.active {
      background-color: #f1f4f8;
    }
  }
  .autocomplete-items .item-detail:hover {
    background-color: #f1f4f8;
  }
}
/**
 * ==============================================
 * Dot Stretching
 * ==============================================
 */
.dot-stretching {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  transform: scale(1.25, 1.25);
  animation: dot-stretching 2s infinite ease-in;
}

.dot-stretching::before,
.dot-stretching::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-stretching::before {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  animation: dot-stretching-before 2s infinite ease-in;
}

.dot-stretching::after {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #4c8ce4;
  color: #4c8ce4;
  animation: dot-stretching-after 2s infinite ease-in;
}

@keyframes dot-stretching {
  0% {
    transform: scale(1.25, 1.25);
  }
  50%,
  60% {
    transform: scale(0.8, 0.8);
  }
  100% {
    transform: scale(1.25, 1.25);
  }
}

@keyframes dot-stretching-before {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%,
  60% {
    transform: translate(-20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}

@keyframes dot-stretching-after {
  0% {
    transform: translate(0) scale(0.7, 0.7);
  }
  50%,
  60% {
    transform: translate(20px) scale(1, 1);
  }
  100% {
    transform: translate(0) scale(0.7, 0.7);
  }
}
.progress-bar-dryness {
  border: solid 1px #007bff !important;
  background-color: #007bff;
  border-radius: 10px !important;
}
.text-redness-dryness {
  font-family: Roboto-Regular;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  color: #4a4a4a;
}
.progress-bar-redness {
  background-color: #f16559;
  border: solid 1px #f16559 !important;
  border-radius: 15px !important;
}
.Image-Orange-Light-Image-1 {
  width: 66.5px;
  height: 66.5px;
  flex-grow: 0;
  margin: 0 8.8px 0 0;
}
span.rank-redness {
  width: 68px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.41px;
  text-align: center;
  color: #f16559;
}
span.rank-dryness {
  width: 68px;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.41px;
  text-align: center;
  color: #007bff;
}
.image-edit-mode__image__overview {
  width: 138px;
  height: 139px;
}
.answerSkin {
  width: 100%;
  padding-left: 0px;
}
.progress {
  width: 67px !important;
  height: 9.4px;
  border-radius: 15px;
  background-color: white;
}
.skin-left-margin {
  margin-left: 14px !important;
}
.dryness-left-margin {
  margin-left: 120px !important;
  margin-top: -21px;
}
.progress-dryness {
  border: solid 1px #007bff !important;
}
.progress-redness {
  border: solid 1px #f16559 !important;
}
.mr-44 {
  margin-right: -6px !important;
}
.ml-20-red {
  margin-left: -4px !important;
}
.fRow {
  margin-left: -46px !important;
}
.mr-bottom-5 {
  margin-bottom: 5px;
}
.mb-bottom {
  margin-bottom: 2.5px;
  margin-right: -2.5px !important;
}
.totalScoreLayout {
  float: right;
  position: relative;
  bottom: 28px;
  left: 10rem;
}
.totalScoreText {
  color: #4a4a4a;
  font-weight: bold;
  opacity: 0.5;
  font-size: 14px;
}
.totalScoreBtnValue {
  width: 47px;
  font-size: 12px;
}
.totalValue {
  position: relative;
  right: 1px;
}
/deep/ .image-capture-iframe iframe.ql-video {
  width: 100% !important;
}
.dot-loader {
  display: none;
}
.row {
  flex-wrap: nowrap !important;
}
.wong-baker-count {
  width: 58px;
  height: 54px;
  padding: 19px 16px;
  text-align: center;
  border-radius: 8px;
  border: solid 1px #b0bac9;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #666669;
}
.wong-baker-count-box input[type="number"]::placeholder {
  font-size: 22px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
}
.healthtrack-table.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none !important;
}
.question-text-format {
  overflow-wrap: break-word;
  overflow: auto;
}
</style>